import { render, staticRenderFns } from "./balonmano.vue?vue&type=template&id=3564a63d&scoped=true&"
import script from "./balonmano.vue?vue&type=script&lang=js&"
export * from "./balonmano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3564a63d",
  null
  
)

export default component.exports